import React, { useState, useEffect, useCallback } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Grid,
  Box,
  Typography,
  IconButton,
  Switch,
  FormGroup,
  Tooltip,
  tooltipClasses,
  Autocomplete,
  TooltipProps,
} from '@mui/material'

import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { DataGrid } from '@mui/x-data-grid'
import './AddSpecifications.css'
import CloseIcon from '@mui/icons-material/Close'
import AddOption from './AddOption/AddOption.tsx'
import ArrowUpIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownIcon from '@mui/icons-material/ArrowDownward'
import { useDispatch, useSelector } from 'react-redux'
import { saveSpecifications } from '../../../../reduxadmin/Actions'
import AutoCompleteMultiSelect from './../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx'
import TextAreaComponents from '../../../components/TextAreaComponents/TextAreaComponents.tsx'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import { toast } from 'react-toastify';
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import LoadingView from '../../../components/LoadingView/LoadingView.js';

import ediPencil from "./../../../../assets/icons/editPencil.png";
import EditOption from "./AddOption/EditOption.tsx";

function EditSpecification(props) {
  const { open, onClose, editData, var1, setvar1 } = props
  const [name, setName] = useState(props.editData ? props.editData.addOnName : '')
  const [buttonStyle, setButtonStyle] = useState('')
  const [maxSelection, setMaxSelection] = useState()
  const [buttonId, setButtonId] = useState(editData.optionButtonId)
  const [anyValue, setAnyValue] = useState("")
  const [textBox, setTextBox] = useState('')
  const [isAnyVisible, setIsAnyVisible] = useState(false)
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [isTextBoxVisible, setIsTextBoxVisible] = useState(false)
  const [isOptionVisible, setIsOptionVisible] = useState(false)
  const [rows, setRows] = useState([{ id: 1, name: 'Cake', price: '$4' }])
  const dispatch = useDispatch();
  const specifications = useSelector(state => state.specifications);
  const [inclusivePrice, setInclusivePrice] = useState(0);

  const apiAddress = process.env.REACT_APP_SECRET;
  const Restauranttoken = JSON.parse(localStorage.getItem('restaurant'));
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false)
  const [loadingModal, SetloadingModal] = React.useState(false);

  // Price related states
  const [basePrice, setBasePrice] = useState(editData.basePrice);
  // const [percentage, setPercentage] = useState(editData.vaTinPercentage);
  // const [vat, setVat] = useState(0);
  const [percentage, setPercentage] = useState(editData.vaTinPercentage || 0);
  const [vat, setVat] = useState(
    getPercentageOrAmount(editData.basePrice, editData.vaTinPercentage, "amount")
  );
  const [sdPercentage, setSDPercentage] = useState(editData.sDinPercentage);
  const [sd, setSD] = useState(0);
  const [newInclusive, setNewInclusive] = useState(editData.priceInclusiveVAT);
  const [minQty, setMinQty] = useState(editData.minQuantity);
  const [maxQty, setMaxQty] = useState(editData.maxQuantity);
  const [increamentalQty, setIncreamentalQty] = useState(editData.increamentalQuantity);
  const [isCountable, setIsCountable] = useState(editData.isCountable);
  const [isCountableActive, setIsCountableActive] = useState(
    editData.optionData?.some(option => option.isCountable) || false
  );
  const [isSdSwitchActive, setIsSdSwitchActive] = useState(
    editData.optionData?.some(option => option.isSD) || false
  );

  // // SD and VAT on SD related states
  // const [customSD, setCustomSD] = useState("");
  // const [sdDatas, setsdDatas] = useState([]);
  // const [sdAdded, setsdAdded] = useState(null);
  // const [SdAmount, setSdAmount] = useState(0);
  // const [SdInAmount, setSdInAmount] = useState(0.0);
  // const [radiovalueSD, setRadiovalueSD] = useState("auto");
  // const [radiovalueVatonSD, setRadiovalueVatonSD] = useState("auto");
  // const [customVatonSD, setCustomVatonSD] = useState("");
  // const [vatOnSdAdded, setVatOnSdAdded] = useState(null);
  // const [VatOnSdAmount, setVatOnSdAmount] = useState(0);
  // const [VatOnSdInAmount, setVatOnSdInAmount] = useState(0.0);
  // const [vatDatas, setvatDatas] = useState([]);
  // const [vatAmount, setVatAmount] = useState(0);
  // const [vatOnSdId, setVatOnSdId] = useState(null);
  // const [vatOnSdType, setVatOnSdType] = useState(null);
  // const [sdType, setSdType] = useState(null);
  // const [sdId, setSdId] = useState(null);
  const [sdSwitch, setsdSwitch] = useState(false);
  const [sdEnabled, setsdEnabled] = useState(true);

  const [radiovalueSD, setRadiovalueSD] = useState("auto");
  const [customSD, setCustomSD] = useState("");
  const [sdAdded, setsdAdded] = useState(null);
  const [SdAmount, setSdAmount] = useState(0);
  const [SdInAmount, setSdInAmount] = useState(0.0);
  const [sdType, setSdType] = useState(null);
  const [sdDatas, setsdDatas] = useState([]);
  const [sdId, setSdId] = useState(null);

  const [radiovalueVatonSD, setRadiovalueVatonSD] = useState("auto");
  const [customVatonSD, setCustomVatonSD] = useState("");
  const [vatOnSdAdded, setVatOnSdAdded] = useState(null);
  const [VatOnSdAmount, setVatOnSdAmount] = useState(0);
  const [VatOnSdInAmount, setVatOnSdInAmount] = useState(0.0);
  const [vatDatas, setvatDatas] = useState([]);
  const [vatOnSdId, setVatOnSdId] = useState(null);
  const [vatOnSdType, setVatOnSdType] = useState(null);

  // Validation states
  const [MaxQtyLimitErr, setMaxQtyLimitErr] = useState(false);
  const [MinQtyLimitErr, setMinQtyLimitErr] = useState(false);
  const [increamentalLimitErr, setincreamentalLimitErr] = useState(false);
  const [increamentalOverLimitErr, setincreamentalOverLimitErr] = useState(false);

  // Other states
  const [switchCheck, setswitchCheck] = useState(false)
  const [hasAddonCheck, setHasAddonCheck] = useState(false)
  const [switchCollapsableCheck, setswitchCollapsableCheck] = useState(props.editData ? props.editData.isCollapsibleOption : false)
  const [switchQuantityCheck, setQuantityCheck] = useState(false)
  const [switchUserCanSelectQty, setSwitchUserCanSelectQty] = useState(true);
  const [hasOption, setHasOption] = useState(false);
  const [minSelection, setMinSelection] = useState("");
  const [isactive, setIsactive] = React.useState(false);

  const [OpenEditOption, setOpenEditOption] = useState(false);
  const [EditOptionObj, setEditOptionObj] = useState(false);

  const handleEditOptionClose = () => {
    setOpenEditOption(false)
  };

  const onEditClick = async (props) => {
    setOpenEditOption(true)
    setEditOptionObj(props)
    console.log("props", props);
  }
  const calcForward = ({
  base,
  vatP = 0,
  sdP = 0,
  vatOnSdP = 0,
  fixedSD = 0
}) => {
  const vat = base * vatP;
  const sd = fixedSD > 0 ? fixedSD : base * sdP;
  const vatOnSd = sd * vatOnSdP;
  const inclusive = base + vat + sd + vatOnSd;

  return { vat, sd, vatOnSd, inclusive };
};

const calcReverse = ({
  inclusive,
  vatP = 0,
  sdP = 0,
  vatOnSdP = 0,
  fixedSD = 0
}) => {
  const divisor = 1 + vatP + sdP + (sdP * vatOnSdP);
  if (divisor <= 0) return null;

  const base = (inclusive - fixedSD) / divisor;
  const vat = base * vatP;
  const sd = fixedSD > 0 ? fixedSD : base * sdP;
  const vatOnSd = sd * vatOnSdP;

  return { base, vat, sd, vatOnSd };
};

  // Initialize data
  // useEffect(() => {
  //   console.log('Updated editData:', props.editData);
  //   console.log('Updated optionData:', props.editData?.optionData);

  //   if(props.editData.sDinPercentage && props.editData.sDinPercentage != 0){
  //     setsdSwitch(true);
  //     setsdEnabled(false);
  //     setRadiovalueSD("Specify"); // Or "auto" depending on your logic
  //     setSdInAmount(props.editData.sDinPercentage);
  //     setSdAmount(props.editData.sDinAmount || 0);
  //   }

  //   // Load VAT data
  //   axios.get(apiAddress + "/api/Vat/GetAllVatListByRestaurantIdAsync?restaurantId=" + Restauranttoken?.id)
  //     .then((response) => {
  //       var list = [];
  //       response.data?.map((dt, i) => {
  //         var obj = {
  //           id: dt.id,
  //           title: dt.name,
  //           percentage: dt.percentage
  //         };
  //         list.push(obj);
  //       });
  //       setvatDatas(list);
  //     });

  //   // Calculate initial values
  //   const initialVat = (basePrice * percentage) / 100;
  //   const initialSd = (basePrice * sdPercentage) / 100;
  //   const initialVatOnSd = (initialSd * VatOnSdInAmount) / 100;

  //   setVat(initialVat);
  //   setSD(initialSd);
  //   setVatOnSdAmount(initialVatOnSd);
  //   setNewInclusive(basePrice + initialVat + initialSd + initialVatOnSd);

  // }, [props.editData]);

  console.log(props.editData)

  useEffect(() => {
    // Fetch VAT/SD lists
    axios
      .get(
        apiAddress +
        "/api/Vat/GetAllVatListByRestaurantIdAsync?restaurantId=" +
        Restauranttoken?.id
      )
      .then((response) => {
        const list = response.data?.map((dt) => ({
          id: dt.id,
          title: dt.name,
          percentage: dt.percentage,
        }));
        setvatDatas(list);
        setsdDatas(list);
      });
  }, []);
  useEffect(() => {
    if (sdAdded && sdAdded.percentage) {
      setIsactive(false);
      setSdInAmount(sdAdded.percentage);
      const total = ((sdAdded.percentage / 100) * basePrice).toFixed(2);
      setSdAmount(total);
    } else if (customSD) {
      setSdInAmount(customSD);
      const total = ((customSD / 100) * basePrice).toFixed(2);
      setSdAmount(total);
    } else {
      setSdInAmount(0);
      setSdAmount(0);
    }
  }, [sdAdded, customSD, basePrice]);

  useEffect(() => {
    if (vatOnSdAdded && vatOnSdAdded.percentage) {
      setIsactive(false);
      setVatOnSdInAmount(vatOnSdAdded.percentage);
      const total = ((vatOnSdAdded.percentage / 100) * SdAmount).toFixed(2);
      setVatOnSdAmount(total);
    } else if (customVatonSD) {
      setVatOnSdInAmount(customVatonSD);
      const total = ((customVatonSD / 100) * SdAmount).toFixed(2);
      setVatOnSdAmount(total);
    } else {
      setVatOnSdInAmount(0);
      setVatOnSdAmount(0);
    }
  }, [vatOnSdAdded, customVatonSD, SdAmount]);

  // Helper functions
  function getPercentageOrAmount(amount1: number, amount2: number, mode: string): number | string {
    if (mode === 'percentage') {
      return (amount2 / amount1) * 100;
    } else if (mode === 'amount') {
      return (amount1 * amount2) / 100;
    } else {
      return 'Invalid mode';
    }
  }

  const updateInclusive = (basePrice, vat, sd, vatOnSd) => {
    const inclusivePrice = parseFloat(basePrice) + parseFloat(vat) + parseFloat(sd) + parseFloat(vatOnSd);
    setNewInclusive(inclusivePrice.toFixed(2));
  };

  // Handlers
  // const handleBasePrice = (e) => {
  //   const newBasePrice = e.target.value;
  //   setBasePrice(newBasePrice);

  //   const updatedVat = (newBasePrice * percentage) / 100;
  //   const updatedSd = (newBasePrice * SdInAmount) / 100;
  //   const updatedVatOnSd = (updatedSd * VatOnSdInAmount) / 100;

  //   setVat(updatedVat.toFixed(2));
  //   setSD(updatedSd.toFixed(2));
  //   setVatOnSdAmount(updatedVatOnSd.toFixed(2));
  //   updateInclusive(newBasePrice, updatedVat, updatedSd, updatedVatOnSd);
  // }
const handleBasePrice = (e) => {
  const base = parseFloat(e.target.value) || 0;
  setBasePrice(base);

  const vatP = (percentage || 0) / 100;
  const sdP = (SdInAmount || 0) / 100;
  const vatOnSdP = (VatOnSdInAmount || 0) / 100;
  const fixedSD = radiovalueSD === "Fixed" ? parseFloat(SdAmount) || 0 : 0;

  const r = calcForward({ base, vatP, sdP, vatOnSdP, fixedSD });

  setVat(r.vat.toFixed(2));
  setSD(r.sd.toFixed(2));
  setVatOnSdAmount(r.vatOnSd.toFixed(2));
  setNewInclusive(r.inclusive.toFixed(2));
};

const handleInclusiveChange = (e) => {
  const inclusive = parseFloat(e.target.value) || 0;
  setNewInclusive(inclusive);

  const vatP = (percentage || 0) / 100;
  const sdP = (SdInAmount || 0) / 100;
  const vatOnSdP = (VatOnSdInAmount || 0) / 100;
  const fixedSD = radiovalueSD === "Fixed" ? parseFloat(SdAmount) || 0 : 0;

  const r = calcReverse({ inclusive, vatP, sdP, vatOnSdP, fixedSD });
  if (!r) return;

  setBasePrice(r.base.toFixed(2));
  setVat(r.vat.toFixed(2));
  setSD(r.sd.toFixed(2));
  setVatOnSdAmount(r.vatOnSd.toFixed(2));
};

  const handleSetVat = (e) => {
    const newVat = e.target.value;
    setVat(newVat);

    const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(newVat), "percentage").toFixed(2);
    if (!isNaN(value)) {
      setPercentage(value);
    }

    updateInclusive(basePrice, newVat, sd, VatOnSdAmount);
  }

  const handleSetPercentage = (e) => {
    const percentageAmount = e.target.value;
    setPercentage(percentageAmount);

    const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(percentageAmount), "amount").toFixed(2);
    if (!isNaN(value)) {
      setVat(value);
      updateInclusive(basePrice, value, sd, VatOnSdAmount);
    }
  }

  // const handleRadioChangeSD = (event) => {
  //   const value = event.target.value;
  //   setRadiovalueSD(value);
  //   setSdType(value);

  //   if (value === "Specify") {
  //     setsdAdded(null);
  //     setCustomSD("");
  //     setSdId(null);
  //     setSdAmount(0);
  //   } else if (value === "auto") {
  //     setCustomSD("");
  //     setSdAmount(0);
  //     setSdId(sdAdded?.id || null);
  //   } else if (value === "Fixed") {
  //     setSdAmount(0);
  //     setSdInAmount("");
  //     setSdId(null);
  //   }
  // };
  const handleRadioChangeSD = (event) => {
    const value = event.target.value;
    setRadiovalueSD(value);
    if (value === "Specify") {
      setsdAdded(null);
      setCustomSD("");
      setSdId(null);
      setSdAmount(0);
    } else if (value === "auto") {
      setCustomSD("");
      setSdAmount(0);
      setSdId(sdAdded?.id || null);
    } else if (value === "Fixed") {
      setSdAmount(0);
      setSdInAmount("");
      setSdId(null);
    }
  };

  const inAmountSDValue = (props) => {
    if (radiovalueSD === "Fixed") {
      setSdAmount(props);
      updateInclusive(basePrice, vat, props, VatOnSdAmount);
    }
  };

  // const handleRadioChangeVatOnSD = (event) => {
  //   const value = event.target.value;
  //   setRadiovalueVatonSD(value);
  //   setVatOnSdType(value);

  //   if (value === "Specify") {
  //     setVatOnSdAdded(null);
  //     setCustomVatonSD("");
  //     setVatOnSdId(null);
  //   } else {
  //     setCustomVatonSD("");
  //     setVatOnSdId(vatOnSdAdded?.id || null);
  //   }
  // };
  const handleRadioChangeVatOnSD = (event) => {
    const value = event.target.value;
    setRadiovalueVatonSD(value);
    if (value === "Specify") {
      setVatOnSdAdded(null);
      setCustomVatonSD("");
      setVatOnSdId(null);
    } else {
      setCustomVatonSD("");
      setVatOnSdId(vatOnSdAdded?.id || null);
    }
  };
  // const handleSDSwitch = () => {
  //   if (sdSwitch == false) {
  //     setsdSwitch(true);
  //     setsdEnabled(false);
  //   } else {
  //     setsdSwitch(false);
  //     setsdEnabled(true);
  //     setSDPercentage(0);
  //     setSD(0);
  //     setSdInAmount(0);
  //     setSdAmount(0);
  //     updateInclusive(basePrice, vat, 0, VatOnSdAmount);
  //   }
  // };
  // const handleSDSwitch = () => {
  //   if (sdSwitch === false) {
  //     setsdSwitch(true);
  //     setsdEnabled(false);
  //   } else {
  //     setsdSwitch(false);
  //     setsdEnabled(true);
  //     setSDPercentage(0);
  //     setSD(0);
  //     setSdInAmount(0);
  //     setSdAmount(0);
  //     setVatOnSdAdded(null);         // Clear Vat On SD selection
  //      setVatOnsdPercentage(0);       // Clear Vat On SD percentage
  //     setVatOnsd(0);                 // Clear Vat On SD amount/value
  //     updateInclusive(basePrice, vat, 0, 0); // Recalculate inclusive price with SD and Vat On SD as 0
  //   }
  // };

  const handleSDSwitch = () => {
    if (isSdSwitchActive) return; // Prevent toggle if SD is active from options

    setsdSwitch(!sdSwitch);
    setsdEnabled(sdSwitch);

    if (!sdSwitch) {
      // Clear SD values when turning off
      setsdAdded(null);
      setCustomSD("");
      setSdInAmount(0);
      setSdAmount(0);
      setRadiovalueSD("auto");
    }
  };

  const handleIsCountable = () => {
    if (isCountableActive) return; // Prevent toggle if countable is active from options

    setIsCountable(!isCountable);

    if (!isCountable) {
      // Clear countable values when turning off
      setMinQty('');
      setMaxQty('');
      setIncreamentalQty('');
    }
  };

  const [VatOnsdPercentage, setVatOnsdPercentage] = useState(editData.vatInSDPercentage);
  const [VatOnsd, setVatOnsd] = useState(getPercentageOrAmount(sd, VatOnsdPercentage, "amount").toFixed(2));


  const handleSetVatOnSDPercentage = (e) => {
    const sdPercentage = e.target.value;
    setVatOnsdPercentage(sdPercentage);

    const value = getPercentageOrAmount(parseFloat(sd), parseFloat(sdPercentage), "amount").toFixed(2);

    if (value) {
      setVatOnsd(value);
      updateInclusive(basePrice, vat, sd, value)
    }
  };

  //tooltip start
  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 320,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));


  //tooltip end







  useEffect(() => {

    if (props.editData.sDinPercentage && props.editData.sDinPercentage != 0) {
      setsdSwitch(true);
      setsdEnabled(false)
    }
  }, [props.editData]);

  const handleInclusive = (amountArray: string[]) => {
    const isListOfString = Array.isArray(amountArray) && amountArray.every(item => typeof item === 'string');

    if (isListOfString) {
      const newArray = amountArray.map((item) => parseFloat(item))
      return newArray.reduce((accumulator, currentValue) => accumulator + currentValue, 0.0);
    }
    return 0;
  };



  // Define setUpdateOptionsRank before moveUp/moveDown
  const setUpdateOptionsRank = (option: OptionRowType) => {
    setAddOnOptionData(prev => ({
      ...prev,
      UpdateOptionsRank: {
        optionId: option.id,
        optionQuantity: option.optionQuantity || 0,
        rank: option.rank,
        subOptionIds: option.suboption?.map(sub => ({
          subOptionId: sub.id,
          subOptionQuantity: sub.subOptionQuantity || 0
        })) || []
      }
    }));
  };

  // const moveUp = (index) => {
  //   if (index === 0) return; // Can't move the first row up
  //   const newRows = [...rowsData];
  //   [newRows[index - 1], newRows[index]] = [newRows[index], newRows[index - 1]];

  //   // Update serial numbers
  //   newRows[index - 1].rank -= 1;
  //   newRows[index].rank += 1;
  //   setRowsData(newRows);
  //   setUpdateOptionsRank(newRows[index]);
  // };

  // In your moveUp and moveDown functions


  // const moveDown = (index) => {
  //   if (index === rowsData.length - 1) return; // Can't move the last row down
  //   const newRows = [...rowsData];
  //   [newRows[index], newRows[index + 1]] = [newRows[index + 1], newRows[index]];

  //   // Update serial numbers
  //   newRows[index + 1].rank += 1;
  //   newRows[index].rank -= 1;
  //   setRowsData(newRows);
  //   setUpdateOptionsRank(newRows[index]);
  // }

  const moveUp = (index) => {
    if (index === 0) return;
    const original = rowsData[index];
    const newRows = [...rowsData];
    [newRows[index - 1], newRows[index]] = [newRows[index], newRows[index - 1]];

    // Recompute ranks to be sequential after the swap
    const ranked = newRows.map((row, i) => ({ ...row, rank: i + 1 }));
    setRowsData(ranked);

    // The original item moved to index - 1 → new rank = (index - 1) + 1
    const newIndex = index - 1;
    setAddOnOptionData(prev => ({
      ...prev,
      UpdateOptionsRank: {
        optionId: original?.id,
        rank: newIndex + 1,
        optionQuantity: original?.optionQuantity || 0,
        subOptionIds: original?.suboption?.map(sub => ({
          subOptionId: sub?.id,
          subOptionQuantity: sub?.subOptionQuantity || 0
        })) || []
      }
    }));
  };

  const moveDown = (index) => {
    if (index === rowsData.length - 1) return;
    const original = rowsData[index];
    const newRows = [...rowsData];
    [newRows[index], newRows[index + 1]] = [newRows[index + 1], newRows[index]];

    // Recompute ranks to be sequential after the swap
    const ranked = newRows.map((row, i) => ({ ...row, rank: i + 1 }));
    setRowsData(ranked);

    // The original item moved to index + 1 → new rank = (index + 1) + 1
    const newIndex = index + 1;
    setAddOnOptionData(prev => ({
      ...prev,
      UpdateOptionsRank: {
        optionId: original?.id,
        rank: newIndex + 1,
        optionQuantity: original?.optionQuantity || 0,
        subOptionIds: original?.suboption?.map(sub => ({
          subOptionId: sub?.id,
          subOptionQuantity: sub?.subOptionQuantity || 0
        })) || []
      }
    }));
  };



  const handleSetSD = (e) => {
    const newSd = e.target.value;
    setSD(newSd);

    const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(newSd), "percentage").toFixed(2);
    if (value) {
      setSDPercentage(value);
    }

    updateInclusive(basePrice, vat, newSd, VatOnsd);
  }

  const handleSetSDPercentage = (e) => {
    const sdPercentage = e.target.value;
    setSDPercentage(sdPercentage);

    const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(sdPercentage), "amount").toFixed(2);

    if (value) {
      setSD(value);
      updateInclusive(basePrice, vat, value, VatOnsd)
    }
  };

  // const handelMinQty = (e) => {
  //   const newMinQty = e.target.value;
  //   setMinQty(newMinQty)
  // }
  //   const handelMinQty = (e) => {

  //   if (e.target.value <= 0 && isCountable == true) {
  //     setMinQtyLimitErr(true);
  //   } else {
  //     setMinQtyLimitErr(false);
  //   }
  //   //setMinQty(props);
  //   //setMinQtyErr(false);
  //   const minQuantity = e.target.value;
  //   console.log('minQuantity',minQuantity)
  //   setMinQty(minQuantity);
  // };

  const handelMinQty = (e) => {
    // const value = e.target.value;
    const value = e.target.value.replace(/^0+/, '');
    if (isCountable && (value === '' || Number(value) <= 0)) {
      setMinQtyLimitErr(true);
      setMinQty(value);
    } else {
      setMinQtyLimitErr(false);
      setMinQty(value);
    }
  };

  // const handelMaxQty = (e) => {
  //   const newMaxQty = e.target.value;
  //   setMaxQty(newMaxQty)
  // }

  const handelMaxQty = (e) => {
    if (e.target.value <= 0 && isCountable == true) {
      setMaxQtyLimitErr(true);
    } else {
      setMaxQtyLimitErr(false);
    }
    const maxQuantity = e.target.value;
    setMaxQty(maxQuantity);
  };

  // const handelincreamentalQty = (e) => {
  //   const newIncrementalValue = e.target.value;
  //   setIncreamentalQty(newIncrementalValue);
  // }
  const handelincreamentalQty = (e) => {

    if (e.target.value <= 0 && isCountable == true) {
      setincreamentalLimitErr(true);
    } else {
      setincreamentalLimitErr(false);
    }

    if (e.target.value > maxQty && isCountable == true) {
      setincreamentalOverLimitErr(true);
    } else {
      setincreamentalOverLimitErr(false);
    }
    const incrementalQuantity = e.target.value;
    setIncreamentalQty(incrementalQuantity);
  };
  // const handleIsCountable = () => {
  //   //setIsCountable(!isCountable);

  //   if (isCountable == true) {
  //     setIsCountable(false)
  //     setMaxQty(0)
  //     setMinQty(0)
  //     setIncreamentalQty(0)
  //   }
  // };

  //   const handleIsCountable = () => {
  //   //setIsCountable(!isCountable);

  //   if (isCountable == true) {
  //     setIsCountable(false)
  //     if (!!minQty != false) {
  //       setMinQty('')
  //       setMinQtyLimitErr(false)
  //     }
  //     if (!!maxQty != false) {
  //       setMaxQty('')
  //       setMaxQtyLimitErr(false)
  //     }
  //     if (!!increamentalQty != false) {
  //       setIncreamentalQty('')
  //       setincreamentalLimitErr(false)
  //       setincreamentalOverLimitErr(false)
  //     }
  //   }
  //   else if (isCountable == false) {
  //     setIsCountable(!isCountable);
  //     setButtonId(3)
  //   }
  // };


  //   const handleIsCountable = () => {
  //   if (isCountable) {
  //     setIsCountable(false);
  //     if (!!minQty !== false) {
  //       setMinQty('');
  //       setMinQtyLimitErr(false);
  //     }
  //     if (!!maxQty !== false) {
  //       setMaxQty('');
  //       setMaxQtyLimitErr(false);
  //     }
  //     if (!!increamentalQty !== false) {
  //       setIncreamentalQty('');
  //       setincreamentalLimitErr(false);
  //       setincreamentalOverLimitErr(false);
  //     }
  //   } else {
  //     setIsCountable(true);
  //     // If all fields are empty or zero, set defaults
  //     if (!minQty || minQty === '0' || minQty === 0) setMinQty();
  //     if (!increamentalQty || increamentalQty === '0' || increamentalQty === 0) setIncreamentalQty();
  //     if (!maxQty || maxQty === '0' || maxQty === 0) setMaxQty();
  //     setButtonId(3);
  //   }
  // };
  // const handleIsCountable = () => {
  //   if (isCountable) {
  //     setIsCountable(false);
  //     setMinQty('');
  //     setMinQtyLimitErr(false);
  //     setMaxQty('');
  //     setMaxQtyLimitErr(false);
  //     setIncreamentalQty('');
  //     setincreamentalLimitErr(false);
  //     setincreamentalOverLimitErr(false);
  //   } else {
  //     setIsCountable(true);
  //     setButtonId(3);
  //     // Do NOT pre-fill any value here
  //   }
  // };


  const isActive = isButtonVisible || isTextBoxVisible;
  useEffect(() => {
    if (isActive) {
      setBasePrice(0);
      setVat(0);
      setPercentage(0);
      setSD(0);
      setSDPercentage(0);
      setNewInclusive(0);
      setMinQty(0);
      setMaxQty(0);
      setIncreamentalQty(0);
      setsdEnabled(true);

      setIsCountableActive(true);
    }
  }, [isActive])
  console.log("edit data: ", editData)

  useEffect(() => {
    if (isCountableActive) {
      setIsCountable(false); // Switch off
      setMinQty(0);
      setIncreamentalQty(0);
      setMaxQty(0);
    }
  }, [isCountableActive]);

  //radio button size start
  const radioSpecification = {
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
    },
    '& .MuiTypography-root': {
      fontSize: '16px',
    },
  }
  //radio button size end

  const handleClose = () => {
    onClose()
  }

  const [defaultOption, setdefaultoption] = useState([])
  console.log('defaultOption', defaultOption)
  const [tempdefaultOption, setTempdefaultoption] = useState([])


  useEffect(() => {
    console.log("defaultOption", defaultOption)
  }, [defaultOption])

  useEffect(() => {
    // if (props.editData && Array.isArray(props.editData.optionData)) {
    //   const options = props.editData.optionData ?? [];

    //   console.log("optionData:", options);
    //   console.log("editData:", props.editData);

    //   setTempdefaultoption(options);
    //   setdefaultoption(options);
    //   setOptionVal(options);

    //   // Use the variable, not state
    //   loadOptionByRestaurant();
    //   loadOptionSuboptionListByOptionI(options);
    if (props.editData?.optionData) {
      const options = Array.isArray(props.editData.optionData)
        ? props.editData.optionData
        : [];

      setdefaultoption(options);
      setOptionVal(options);
      loadOptionSuboptionListByOptionI(options);


      const { optionButtonId, maxSelection, textBoxName } = props.editData;

      switch (optionButtonId) {
        case 3:
          setButtonStyle("Radio Button");
          setIsAnyVisible(true);
          setAnyValue(maxSelection);
          setHasOption(true);
          setIsOptionVisible(true);
          setMinSelection(props.editData.minSelection)
          break;
        case 4:
          setButtonStyle("Check Box");
          setIsAnyVisible(true);
          setAnyValue(maxSelection);
          setHasOption(true);
          setIsOptionVisible(true);
          setMinSelection(props.editData.minSelection)
          break;
        case 5:
          setButtonStyle("Button");
          setIsButtonVisible(true);
          setHasOption(true);
          break;
        case 6:
          setButtonStyle("TextBox");
          setIsTextBoxVisible(true);
          setTextBox(textBoxName);
          setHasOption(true);
          break;
      }
    }
  }, [props.editData?.optionData]);


  useEffect(() => {
    if (props.data !== undefined) {
      setName(props.data.Header);
      setButtonStyle(props.data.ButtonStyle);
      setAnyValue(props.data.any);
      setTextBox(props.data.TextBox);

      setIsAnyVisible(props.data.ButtonStyle === 'Check Box' || props.data.ButtonStyle === 'Check Box');
      setIsButtonVisible(props.data.ButtonStyle === 'Button');
      setIsTextBoxVisible(props.data.ButtonStyle === 'TextBox');
      setIsOptionVisible(
        props.data.ButtonStyle === 'Check Box' ||
        props.data.ButtonStyle === 'Radio Button' ||
        props.data.ButtonStyle === 'Button'
      );

      setRows(props.data.options.map((option, index) => ({
        id: index + 1,
        name: option.name,
        price: option.price,
      })))
      console.log(props.data)
    }
  }, [props.data]);


  const handleNameChange = (event) => {
    setName(event.target.value)
  }
  //show textfield and datagrid based on radio option start
  const handleButtonStyleChange = (event) => {
    setButtonStyle(event.target.value);
    setIsAnyVisible(event.target.value === 'Check Box' || event.target.value === 'Radio Button');
    setIsButtonVisible(event.target.value === 'Button');
    setIsTextBoxVisible(event.target.value === 'TextBox');
    setIsOptionVisible(event.target.value === 'Check Box' || event.target.value === 'Radio Button' || event.target.value === 'Button');
    if (event.target.value === 'Radio Button') {
      setButtonId(3);
      setAnyValue(1);
      setMaxSelection(1);
      setMinSelection(0);
    }
    else if (event.target.value === 'Check Box') {
      setButtonId(4);
      setAnyValue('');
      setMaxSelection('');
      setMinSelection('');
    }
    else if (event.target.value === 'TextBox') {
      setButtonId(6);
    }
    else {
      setButtonId(5);
    }
  };

  //show textfield and datagrid based on radio option end

  const handleAnyValueChange = (props) => {
    if (buttonId === 3) {
      // Radio Button selected - Max Selection should always be 1 and not editable
      return;
    } else {
      setMaxSelection(props);
      setAnyValue(props);
    }
  }

  const AddMaximumOrderValue = (props) => {
    setAnyValue(props);

  };

  const handleTextBoxChange = (event) => {
    setTextBox(event.target.value)
  }
  const nameFieldValue = (props) => {
    setName(props)
  }

  const textFieldValue = (props) => {
    console.log(props)
  }
  const handleAddOptionSave = (option) => {
    const newRow = {
      id: rows.length + 1,
      name: option.name,
      price: option.price,
    }
    setRows((prevRows) => [...prevRows, newRow])
  }
  // row re-order functionality start
  const handleRowMove = (rowId, direction) => {
    setRows((prevRows) => {
      const rowIndex = prevRows.findIndex((row) => row.id === rowId)
      const newRow = prevRows[rowIndex]
      const newRows = [...prevRows]

      if (direction === 'up' && rowIndex > 0) {
        newRows.splice(rowIndex, 1) // Remove the row from the current position
        newRows.splice(rowIndex - 1, 0, newRow) // Insert the row at the new position
      } else if (direction === 'down' && rowIndex < prevRows.length - 1) {
        newRows.splice(rowIndex, 1) // Remove the row from the current position
        newRows.splice(rowIndex + 1, 0, newRow) // Insert the row at the new position
      }

      // Update the ids of the rows based on their new positions
      const updatedRows = newRows.map((row, index) => ({
        ...row,
        id: index + 1,
      }))

      return updatedRows
    })
  }

  const handleSwitchChange = () => {
    setswitchCheck(!switchCheck)
  }
  const handleHasAddonCheck = () => {
    setHasAddonCheck(!hasAddonCheck)
  }

  const handleswitchCollapsableCheck = () => {
    setswitchCollapsableCheck(!switchCollapsableCheck)
  }

  const handlesetQuantityCheck = () => {
    setQuantityCheck(!switchQuantityCheck)
  }
  // row re-order functionality end

  //datagrid customization start
  const columns = [
    {
      field: 'id',
      headerName: 'Rank',
      width: 117,
      headerClassName: 'SpecificationHeader',
      renderCell: (params) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#e7e7e9',
            width: '6rem',
            borderRadius: '5px',
            justifyContent: 'center',
          }}
        >
          <ArrowDownIcon
            style={{ cursor: 'pointer', margin: 'auto', width: 16 }}
            onClick={() => handleRowMove(params.row.id, 'down')}
          />
          <span>{params.value}</span>
          <ArrowUpIcon
            style={{ cursor: 'pointer', margin: 'auto', width: 16 }}
            onClick={() => handleRowMove(params.row.id, 'up')}
          />
        </div>
      ),
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 210,
      cellClassName: 'SpecificationGridSel',
      headerClassName: 'SpecificationHeader',
    },
    {
      field: 'price',
      headerName: 'Price',
      width: 112,
      cellClassName: 'SpecificationGridSel',
      headerClassName: 'SpecificationHeader',
    },
  ]

  const [sectionDatas, setSectionDatas] = useState([])

  // const loadOptionByRestaurant = async () => {

  //   if (buttonId == 5) {
  //     axios
  //       .get(
  //         apiAddress +
  //         "/api/AddOnOptionsMaster/GetAddOnOptionsMasterByRestaurantId?restaurantId=" +
  //         Restauranttoken.id +
  //         "&buttonType=Button" +
  //         "&IsCountableChecked=" + isCountable
  //       )
  //       .then((response) => {
  //         console.log(response.data);

  //         var list = [];
  //         // var subOptionList=[];
  //         response.data.map(async (dt, i) => {
  //           var obj = { id: dt.id, title: dt.optionName };
  //           // await loadOptionSuboptionListByOptionI(dt.id)
  //           list.push(obj);
  //         });
  //         setSectionDatas(list);
  //       });
  //   }
  //   else {
  //     axios
  //       .get(
  //         apiAddress +
  //         "/api/AddOnOptionsMaster/GetAddOnOptionsMasterByRestaurantId?restaurantId=" +
  //         Restauranttoken.id +
  //         "&buttonType=Others" +
  //         "&IsCountableChecked=" + isCountable
  //       )
  //       .then((response) => {
  //         console.log(response.data);

  //         var list = [];
  //         // var subOptionList=[];
  //         response.data.map(async (dt, i) => {
  //           var obj = { id: dt.id, title: dt.optionName };
  //           // await loadOptionSuboptionListByOptionI(dt.id)
  //           list.push(obj);
  //         });
  //         setSectionDatas(list);
  //       });
  //   }

  //   // axios
  //   //   .get(apiAddress + "/api/AddOnOptionsMaster/GetAddOnOptionsMasterByRestaurantId?restaurantId=" + Restauranttoken.id)
  //   //   .then((response) => {
  //   //     console.log(response.data)

  //   //     var list = [];
  //   //     // var subOptionList=[];
  //   //     response.data.map(async (dt, i) => {
  //   //       var obj = { id: dt.id, title: dt.optionName }
  //   //       // await loadOptionSuboptionListByOptionI(dt.id)
  //   //       list.push(obj);


  //   //     })
  //   //     setSectionDatas(list)
  //   //     // setdefaultoption(props.editData.optionData)
  //   //   });
  // }


  const loadOptionByRestaurant = async () => {
    if (buttonId == 5) {
      axios
        .get(
          apiAddress +
          "/api/AddOnOptionsMaster/GetAddOnOptionsMasterByRestaurantId?restaurantId=" +
          Restauranttoken.id +
          "&buttonType=Button" +
          "&IsCountableChecked=" + isCountable +
          "&isSDChecked=" + sdSwitch
        )
        .then((response) => {
          console.log(response.data);

          var list = [];
          response.data.map((dt, i) => {
            // Format the title with SD and Countable indicators
            const formattedTitle = `${dt.optionName}${dt.isSD ? " | SD applied" : ""
              }${dt.isCountable ? " | Countable" : ""}`;

            var obj = {
              id: dt.id,
              title: formattedTitle,
              originalName: dt.optionName, // Keep original name if needed
              isSD: dt.isSD,
              isCountable: dt.isCountable
            };
            list.push(obj);
          });
          setSectionDatas(list);
        });
    }
    else {
      axios
        .get(
          apiAddress +
          "/api/AddOnOptionsMaster/GetAddOnOptionsMasterByRestaurantId?restaurantId=" +
          Restauranttoken.id +
          "&buttonType=Others" +
          "&IsCountableChecked=" + isCountable +
          "&isSDChecked=" + sdSwitch
        )
        .then((response) => {
          console.log(response.data);

          var list = [];
          response.data.map((dt, i) => {
            // Format the title with SD and Countable indicators
            const formattedTitle = `${dt.optionName}${dt.isSD ? " | SD applied" : ""
              }${dt.isCountable ? " | Countable" : ""}`;

            var obj = {
              id: dt.id,
              title: formattedTitle,
              originalName: dt.optionName, // Keep original name if needed
              isSD: dt.isSD,
              isCountable: dt.isCountable
            };
            list.push(obj);
          });
          setSectionDatas(list);
        });
    }
  };

  // const loadOptionByRestaurant = async () => {
  //   try {
  //     const url = `${apiAddress}/api/AddOnOptionsMaster/GetAddOnOptionsMasterByRestaurantId?restaurantId=${Restauranttoken.id}&buttonType=${buttonId === 5 ? "Button" : "Others"}`;

  //     const response = await axios.get(url);
  //     const list = response.data.map(dt => ({
  //       id: dt.id,
  //       title: `${dt.optionName}${dt.isSD ? " | SD applied" : ""}${dt.isCountable ? " | Countable" : ""}`,
  //       originalName: dt.optionName,
  //       isSD: dt.isSD,
  //       isCountable: dt.isCountable
  //     }));

  //     setSectionDatas(list);
  //   } catch (error) {
  //     console.error("Error loading options:", error);
  //   }
  // };

  useEffect(() => {

    loadOptionByRestaurant()
  }, [])


  const sectioNames = [
    { id: 1, title: 'Sauces' },
    { id: 2, title: 'Portion size' },
    { id: 3, title: 'Toppings' }
  ]

  const addValue = (props) => {
    console.log(props)
    // setAutoCompleteValue(props)
  }
  //datagrid customization end

  // save option Datagrid valu into filteredRows
  const filteredRows = rows.filter((row) => row.name && row.price)


  const [openOptionDialog, setOpenOptionDialog] = useState(false)

  const handleAddOptionClick = () => {
    setOpenOptionDialog(true)
  }

  const [openAddSubOption, setOpenSubOption] = useState(false)
  const AddSubOptionClicked = () => {
    setOpenSubOption(true)
  }




  //Dynamic Table
  function createData(
    id: string,
    OptionName: string,
    BasePrice: number,
    Vat: number,
    InclusivePrice: number,
    MinQty: number,
    MaxQty: number,
    IsCountable: boolean,
    isSd: boolean,
    sdInAmount: number,
    vatOnSDInAmount: number,
    suboption: [],

  ) {
    return {
      id,
      OptionName,
      BasePrice,
      Vat,
      InclusivePrice,
      MinQty,
      MaxQty,
      IsCountable,
      isSd,
      sdInAmount,
      vatOnSDInAmount,
      suboption
    };
  }

  const [maxVal, setMaxVal] = React.useState(0);

  function Row(props: { row: ReturnType<typeof createData>, idx: number }) {
    const { row, idx } = props;
    const [open, setOpen] = React.useState(false);
    const formattedOptionName = `${row.OptionName}${row.isSd ? " | SD applied" : ""
      }${row.IsCountable ? " | Countable" : ""}`;

    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>

            <IconButton size="small" onClick={() => moveUp(idx)}>
              <ArrowUpIcon sx={{ width: "1.2rem", height: "1.2rem" }} />
            </IconButton>
            <span>{row.rank}</span>
            <IconButton size="small" onClick={() => moveDown(idx)}>
              <ArrowDownIcon sx={{ width: "1.2rem", height: "1.2rem" }} />
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              {formattedOptionName}
              <img
                src={ediPencil}
                alt="edit"
                style={{ width: "1rem", cursor: "pointer" }}
                onClick={() => {
                  onEditClick(row.id);
                }}
              />
            </div>
          </TableCell>
          <TableCell align="right">{row.BasePrice}</TableCell>
          <TableCell align="right">{row.Vat}</TableCell>
          <TableCell align="right">{row.sdInAmount}</TableCell>
          <TableCell align="right">{row.vatOnSDInAmount}</TableCell>
          <TableCell align="right">{row.InclusivePrice}</TableCell>
          <TableCell align="right">{row.MinQty}</TableCell>
          <TableCell align="right">{row.MaxQty}</TableCell>
        </TableRow>

        <TableRow>
          {
            row.suboption.length > 0 ? (
              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <Box sx={{ margin: 1 }}>
                    <Typography variant="h6" gutterBottom component="div">
                      Sub Option
                    </Typography>
                    <TableContainer component={Paper}>
                      <Table aria-label="collapsible table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Option Name</TableCell>
                            <TableCell align="right">Price</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {row.suboption.map((row) => (
                            <SubOptionRow key={row.suboptionName} row={row} />
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>

                  </Box>
                </Collapse>
              </TableCell>

            ) : ""
          }

        </TableRow>
      </React.Fragment>
    );
  }

  function SubOptionRow(props) {
    const { row } = props;
    // const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>

          <TableCell component="th" scope="row">
            {row.subOptionName}
          </TableCell>
          <TableCell align="right">{row.price}</TableCell>
        </TableRow>


      </React.Fragment>
    );
  }
  const [option, setOption] = React.useState([
    {
      suboptionName: 'Hot Sauce',
      subBaseprice: 10,
      // subvat: 1,
      // subinclusivePrice: 11,
    },
    {
      suboptionName: 'mild Sauce',
      subBaseprice: 10,
      // subvat: 1,
      // subinclusivePrice: 11,
    },
    {
      suboptionName: 'Extreme Sauce',
      subBaseprice: 10,
      // subvat: 1,
      // subinclusivePrice: 11,
    }
  ]);
  // const [list, setList]=useState([])
  const [rowsData, setRowsData] = useState([]);
  const [addonsData, setAddOnData] = useState([])
  const [tempRowsData, setTempRowsData] = useState([]);

  // const loadOptionSuboptionListByOptionI = async (props) => {
  //   console.log(props)
  //   if (props != undefined) {
  //     var list = []
  //         let hasCountable = false;
  //     await Promise.all(

  //       props?.map(async (d, i) => {
  //         console.log("loop")
  //         await axios
  //           .get(apiAddress + "/api/AddOnOptionsMaster/GetAddOnOptionsMasterWithSubOptionListById?id=" + d?.id)
  //           .then((response) => {

  //                 if (response.data.addOnOptionsMaster.isCountable) {
  //                   hasCountable = true;
  //                 }
  //             console.log("modal data: ", response.data)
  //             var obj = createData(
  //               d.id,
  //               response.data.addOnOptionsMaster.optionName,
  //               response.data.addOnOptionsMaster.basePrice,
  //               // response.data.addOnOptionsMaster.vaTinPercentage,
  //               // 10,
  //                 response.data.addOnOptionsMaster.vaTinPercentage * 0.01* response.data.addOnOptionsMaster.basePrice,
  //               response.data.addOnOptionsMaster.priceInclusiveVAT,
  //             response.data.addOnOptionsMaster.minQuantity,
  //             response.data.addOnOptionsMaster.maxQuantity,
  //             response.data.addOnOptionsMaster.isCountable,
  //             response.data.addOnOptionsMaster.isSD,
  //             response.data.addOnOptionsMaster.sdInAmount,
  //             response.data.addOnOptionsMaster.vatOnSDInAmount,
  //               response.data.addOnSubOptionsMasterList
  //             )
  //             list.push(obj)

  //           });
  //       })
  //     );
  //     console.log(list)
  //     setTempRowsData(list)
  //     // setRowsData([])
  //     setAddOnData(list)
  //   }
  // }

  const loadOptionSuboptionListByOptionI = async (props) => {
    if (props != undefined) {
      let hasCountable = false;
      let hasSD = false;
      const list = await Promise.all(
        props?.map(async (d, i) => {
          const response = await axios.get(
            apiAddress + "/api/AddOnOptionsMaster/GetAddOnOptionsMasterWithSubOptionListById?id=" + d?.id
          );

          // Check SD and countable flags
          if (response.data.addOnOptionsMaster.isSD) {
            hasSD = true;
          }
          if (response.data.addOnOptionsMaster.isCountable) {
            hasCountable = true;
          }

          return createData(
            d.id,
            response.data.addOnOptionsMaster.optionName,
            response.data.addOnOptionsMaster.basePrice,
            response.data.addOnOptionsMaster.vaTinPercentage * 0.01 * response.data.addOnOptionsMaster.basePrice,
            response.data.addOnOptionsMaster.priceInclusiveVAT,
            response.data.addOnOptionsMaster.minQuantity,
            response.data.addOnOptionsMaster.maxQuantity,
            response.data.addOnOptionsMaster.isCountable,
            response.data.addOnOptionsMaster.isSD,
            response.data.addOnOptionsMaster.sdInAmount,
            response.data.addOnOptionsMaster.vatOnSDInAmount,
            response.data.addOnSubOptionsMasterList
          );
        })
      );

      // Update toggle states based on options
      setIsCountableActive(hasCountable);
      if (hasCountable) {
        setIsCountable(false);
      }

      setIsSdSwitchActive(hasSD);
      if (hasSD) {
        setsdSwitch(false);
        setsdEnabled(true);
      }

      setTempRowsData(list);
      setAddOnData(list);
    }
  };


  useEffect(() => {
    // Preserve existing ranks/order; append new items at the end with next ranks
    const existingById = new Map((rowsData || []).map((r: any) => [r.id, r]));
    const fetchedById = new Map((tempRowsData || []).map((r: any) => [r.id, r]));

    // Keep items that still exist, in their previous order by rank
    const kept = (rowsData || [])
      .filter((r: any) => fetchedById.has(r.id))
      .sort((a: any, b: any) => (a.rank ?? 0) - (b.rank ?? 0))
      .map((r: any) => ({ ...fetchedById.get(r.id), rank: r.rank }));

    // Append newly added items to the end with incremental ranks
    let nextRank = kept.length > 0 ? Math.max(...kept.map((k: any) => k.rank || 0)) + 1 : 1;
    const newOnes = (tempRowsData || [])
      .filter((r: any) => !existingById.has(r.id))
      .map((r: any) => ({ ...r, rank: nextRank++ }));

    setRowsData([...(kept as any[]), ...(newOnes as any[])]);
  }, [tempRowsData])

  useEffect(() => {
    setIsCountableActive(rowsData.some((item) => item.IsCountable));
  }, [rowsData]);

  const [AddOnOptionData, setAddOnOptionData] = useState({
    AddOptions: [],
    RemoveOptions: [],
    UpdateOptionsRank: null
  });

  const [removedItems, setRemovedItems] = useState([]);

  // useEffect(() => {
  //   const transformData = (data) => {
  //     return data.map(option => ({
  //       optionId: option.id,
  //       subOptionIds: option.suboption.map(sub => ({
  //         subOptionId: sub.id
  //       }))
  //     }));
  //   };

  //   const transformedAddOptions = transformData(rowsData);
  //   // const transformedRemoveOptions = transformData(removedItems);

  //   setAddOnOptionData({
  //     AddOptions: transformedAddOptions,
  //     RemoveOptions: removedItems
  //   });
  // }, [rowsData]);

  useEffect(() => {
    const transformData = (data) => {
      return data.map(option => ({
        optionId: option.id,
        rank: option.rank, // Pass rank
        subOptionIds: option.suboption?.map(sub => ({
          subOptionId: sub.id
        })) || []
      }));
    };

    const transformedAddOptions = transformData(rowsData);
    const addOptionIds = new Set(transformedAddOptions.map(o => o.optionId));

    // Keep only removals that are not being added back (compare by optionId)
    let transformedRemoveOptions = removedItems
      .filter(item => item.optionId && item.subOptionIds)
      .filter(item => !addOptionIds.has(item.optionId));

    // De-duplicate RemoveOptions by optionId
    const seenRemove = new Set();
    transformedRemoveOptions = transformedRemoveOptions.filter(item => {
      if (seenRemove.has(item.optionId)) return false;
      seenRemove.add(item.optionId);
      return true;
    });

    setAddOnOptionData(prev => ({
      ...prev,
      AddOptions: transformedAddOptions,
      RemoveOptions: transformedRemoveOptions
    }));
  }, [rowsData, removedItems]);

  console.log("rows data: ", AddOnOptionData, removedItems);

  const [optionVal, setOptionVal] = useState([])

  console.log("optionVal", optionVal);

  useEffect(() => {
    const removeMatchingOptions = () => {
      if (AddOnOptionData.RemoveOptions.length > 0 && AddOnOptionData.AddOptions.length > 0) {
        const addIds = new Set(AddOnOptionData.AddOptions.map(a => a.optionId));

        // Drop any remove item whose optionId is present in AddOptions
        const updatedRemoveOptions = AddOnOptionData.RemoveOptions.filter(removedOption => !addIds.has(removedOption.optionId));

        if (updatedRemoveOptions.length !== AddOnOptionData.RemoveOptions.length) {
          setAddOnOptionData(prevData => ({
            ...prevData,
            RemoveOptions: updatedRemoveOptions
          }));
        }
      }
    };

    removeMatchingOptions();
  }, [AddOnOptionData]);


  const addonvalue = async (props) => {
    setOptionVal(props)
    console.log(props)
    var tempData = [];
    var optionId = []
    props.map((data, index) => {
      // await loadOptionSuboptionListByOptionI(data.id)
      optionId.push(data.id)


    });
    await loadOptionSuboptionListByOptionI(props)
    setAnyValue("")
  }

  const transformSingleData = (data) => {
    return {
      optionId: data?.id,
      subOptionIds: data?.suboption.map((sub) => ({
        subOptionId: sub.id
      }))
    }
  }

  // const handleOptionRemove = (option) => {
  //   const removedId = option.id;

  //   // Find the removed item from your data source (rowsData)
  //   const isRemovedItem = defaultOption.find((dt) => dt.id === removedId);

  //   if (isRemovedItem) {
  //     // Add the new removed item to the existing array of removed items
  //     const removedItem = rowsData.find((dt) => dt.id === isRemovedItem.id)
  //     console.log("rows data 2: ", removedItem)
  //     const transformedRemovedItem = transformSingleData(removedItem)
  //     setRemovedItems((prevItems) => [...prevItems, transformedRemovedItem]);
  //   }
  // };
  const handleOptionRemove = (option) => {
    setRemovedItems(prevItems => {
      // Check if this option exists in the original data (defaultOption)
      const wasOriginallyPresent = defaultOption.some(dt => dt.id === option.id);

      if (wasOriginallyPresent) {
        const transformedItem = {
          optionId: option.id,
          subOptionIds: option.suboption?.map(sub => ({ subOptionId: sub.id })) || []
        };
        return [...prevItems, transformedItem];
      }
      return prevItems;
      
    });
    setAnyValue("")
  };

  const [collapseopen, setcollapseopenOpen] = React.useState(false);

  const [insertView, setInsertView] = useState({
    AddOnsMaster: {
      Id: '123'
    },
  })

  useEffect(() => {
    loadOptionSuboptionListByOptionI(defaultOption)
  }, [sectionDatas])

  useEffect(() => {
    console.log(rowsData)
  }, [rowsData])

  const handleSave = async () => {

    var valid = true;
    setopenConfirmaitonModal(false)

    if (anyValue > optionVal.length.toString()) {
      valid = false;
      toast.error("Number of Options Should be equal or more then Max selection", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (isCountable == true) {
      console.log(minQty)
      console.log(maxQty)
      console.log(increamentalQty)

      // if (parseInt(minQty) <= 0) {
      //   valid = false;
      //   toast.error("Min Qty Can not be 0 or less then 0", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "colored",
      //   });
      // }
      // if (parseInt(maxQty) <= 0) {
      //   valid = false;
      //   toast.error("Max Qty Can not be 0 or less then 0", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "colored",
      //   });
      // }
      if (parseInt(minQty) > parseInt(maxQty)) {
        valid = false;
        toast.error("Max Qty Can not be less then Min Qty", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      // if (parseInt(increamentalQty) <= 0) {
      //   valid = false;
      //   toast.error("Increament Qty Can not be 0 or less then 0", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "colored",
      //   });
      // }
      if (parseInt(increamentalQty) > parseInt(maxQty)) {
        valid = false;
        toast.error("Increament value Can not be more then Max Value", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      // if ((parseInt(increamentalQty) + parseInt(minQty)) > parseInt(maxQty)) {
      //   valid = false;
      //   toast.error("Max Value can not be less then Min and increament value combained", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "colored",
      //   });
      // }
    }



    let vatOnSdId;
    let vatOnSdPercentage;
    let sdId;
    let sdPercentage;
    let sdAmount;

    // SD logic
    if (radiovalueSD === 'auto') {
      sdId = sdAdded?.id;
      sdPercentage = null;
      sdAmount = SdAmount;
    } else if (radiovalueSD === 'Specify') {
      sdId = null;
      sdPercentage = parseFloat(SdInAmount);
      sdAmount = SdAmount;
    } else if (radiovalueSD === 'Fixed') {
      sdId = null;
      sdPercentage = null;
      sdAmount = SdAmount;
    }

    // Vat On SD logic
    if (radiovalueVatonSD === 'auto') {
      vatOnSdId = vatOnSdAdded?.id;
      vatOnSdPercentage = null;
    } else if (radiovalueVatonSD === 'Specify') {
      vatOnSdId = null;
      vatOnSdPercentage = parseFloat(VatOnSdInAmount);
    }

    // If SD switch is off, clear all SD and Vat On SD values
    if (!sdSwitch) {
      sdId = null;
      sdPercentage = null;
      sdAmount = 0;
      vatOnSdId = null;
      vatOnSdPercentage = null;
    }

    if (isCountable && minQty === "") {
      insertView.AddOnsMaster.minQuantity = 0;
    }
    else if (isCountable == true) {
      insertView.AddOnsMaster.minQuantity = minQty ?? 0;
    }
    else if (minQty === "") {
      insertView.AddOnsMaster.minQuantity = 0
    }
    else {
      insertView.AddOnsMaster.minQuantity = minQty ?? 0;
    }

    if (isCountable && maxQty === "") {
      insertView.AddOnsMaster.maxQuantity = 999;
    }
    else if (isCountable == true) {
      insertView.AddOnsMaster.maxQuantity = maxQty ?? 999;
    }
    else if (maxQty === "") {
      insertView.AddOnsMaster.maxQuantity = 0;
    }
    else {
      insertView.AddOnsMaster.maxQuantity = maxQty ?? 999;
    }

    if (isCountable && increamentalQty === "") {
      insertView.AddOnsMaster.increamentalQuantity = 1;
    }
    else if (isCountable) {
      insertView.AddOnsMaster.increamentalQuantity = increamentalQty ?? 1;
    }
    else if (increamentalQty === "") {
      insertView.AddOnsMaster.increamentalQuantity = 0;
    }
    else {
      insertView.AddOnsMaster.increamentalQuantity = increamentalQty ?? 0;
    }

    insertView.AddOnsMaster.Id = editData.id
    insertView.AddOnsMaster.RestaurantId = Restauranttoken.id
    insertView.AddOnsMaster.AddOnName = name
    insertView.AddOnsMaster.IsCollapsibleOption = switchCollapsableCheck
    insertView.AddOnsMaster.OptionButtonId = buttonId
    insertView.AddOnsMaster.MaxSelection = anyValue
    insertView.AddOnsMaster.TextBoxName = textBox
    insertView.AddOnsMaster.CreationId = '123'
    insertView.AddOnsMaster.ModificationId = '123'
    insertView.AddOnsMaster.basePrice = parseFloat(basePrice)
    insertView.AddOnsMaster.vaTinPercentage = parseFloat(percentage)
    // insertView.AddOnsMaster.sDinPercentage = parseFloat(sdPercentage)
    insertView.AddOnsMaster.priceInclusiveVAT = parseFloat(newInclusive)
    // insertView.AddOnsMaster.minQuantity = parseFloat(minQty)
    // insertView.AddOnsMaster.maxQuantity = parseFloat(maxQty)
    // insertView.AddOnsMaster.increamentalQuantity = parseFloat(increamentalQty)
    // insertView.AddOnsMaster.minQuantity = minQtyToSave;
    // insertView.AddOnsMaster.maxQuantity = maxQtyToSave;
    // insertView.AddOnsMaster.increamentalQuantity = increamentalQtyToSave;

    insertView.AddOnsMaster.isCountable = isCountable
    insertView.AddOnsMaster.minSelection = minSelection ?? 0;
    // insertView.AddOnsMaster.vatInSDPercentage = VatOnsdPercentage ?? 0;

    insertView.AddOnsMaster.vatOnSDId = vatOnSdId;
    insertView.AddOnsMaster.vatOnSDType = radiovalueVatonSD;
    insertView.AddOnsMaster.sdId = sdId;
    insertView.AddOnsMaster.SDType = radiovalueSD;
    insertView.AddOnsMaster.sDinPercentage = sdPercentage;
    insertView.AddOnsMaster.sdInAmount = sdAmount;
    insertView.AddOnsMaster.vatInSDPercentage = vatOnSdPercentage;
    insertView.AddOnsMaster.isSD = sdSwitch;

    if (hasOption == true && buttonId == 4) {
      console.log('main if hit')
      if (insertView.AddOnsMaster.MaxSelection == "") {
        console.log('if hit')
        console.log(insertView.AddOnsMaster.MaxSelection)
        insertView.AddOnsMaster.MaxSelection = optionVal.length;
      }
      else {
        insertView.AddOnsMaster.MaxSelection = anyValue ?? 0;
      }
    }
    else {
      insertView.AddOnsMaster.MaxSelection = anyValue ?? 0;
    }

    if (hasOption == true && buttonId == 4) {

      if (!!insertView.AddOnsMaster.minSelection) {

        insertView.AddOnsMaster.minSelection = minSelection ?? 0;
      }
      else {

        insertView.AddOnsMaster.minSelection = 0;
      }
    }
    else {
      console.log('else hit')
      insertView.AddOnsMaster.minSelection = minSelection ?? 0;
    }


    var mapperlist = []
    await rowsData.map((dt, i) => {
      dt.suboption.map((d, i) => {
        var obj = {
          id: "string",
          addOnId: "string",
          optionId: dt.id,
          subOptionId: d.id,
          creationId: "string"
        }
        mapperlist.push(obj)
      })
    })
    insertView.AddOnOptionSubOptionMasterMapperList = mapperlist

    console.log("response data: ", AddOnOptionData)
    console.log(editData.id)

    if (valid) {
      SetloadingModal(true);
      var url = apiAddress + `/api/AddOns/UpdateAddOnsMaster?id=${editData.id}`

      try {
        const response = await axios.put(url, insertView.AddOnsMaster)

        // const res = await axios.put(`${apiAddress}/api/AddOns/UpdateAddOnLinkedOptions?addOnId=${editData.id}`, AddOnOptionData)

        // Send UpdateOptionsRank only when a re-order happened; otherwise null
        const payload = {
          AddOptions: AddOnOptionData.AddOptions || [],
          RemoveOptions: AddOnOptionData.RemoveOptions || [],
          UpdateOptionsRank: AddOnOptionData?.UpdateOptionsRank || null,
        };

        console.log("Sending payload:", JSON.stringify(payload, null, 2));

        const res = await axios.put(
          `${apiAddress}/api/AddOns/UpdateAddOnLinkedOptions?addOnId=${editData.id}`,
          payload
        );

        if (response.status === 200 && res.status === 200) {
          toast.success("Successfully updated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          props.reloadAddons()
          // setButtonStyle('')
          onClose()
        }
      } catch (error) {
        console.log(error);
      } finally {
        SetloadingModal(false);
      }

    }

  }



  useEffect(() => {
    if (minQty > 0 || maxQty > 0 || increamentalQty > 0) {
      if (isCountableActive == false) {
        setIsCountable(true);
      } else {
        setIsCountable(false);
        setMaxQtyLimitErr(false)
        setMinQtyLimitErr(false)
        setincreamentalLimitErr(false)
        setincreamentalOverLimitErr(false)

      }

    }
    else if (minQty === 0 || maxQty === 0 || increamentalQty === 0) {
      setIsCountable(false);
    }
    else {
      setIsCountable(false);
    }
  }, [minQty, maxQty, increamentalQty])

  const ReloadOption = () => {
    loadOptionByRestaurant()
  }


  const handleUserCanSelectQty = () => {
    setSwitchUserCanSelectQty(!switchUserCanSelectQty);
  };



  // const handleHasOption = () => {
  //   if (hasOption == false) {
  //     setHasOption(true)
  //   }
  //   else if (hasOption == true) {
  //     // setHasOption(false)
  //     // setIsAnyVisible(false);
  //     // setIsOptionVisible(false)
  //     // setButtonId(0);
  //     // setAnyValue(0);
  //     // setMinSelection(0)
  //     // setMaxSelection(0)
  //     // setTextBox('');
  //     // setOptionVal([]);
  //     // setRowsData([]);
  //     const removedOptions = optionVal.map(option => ({
  //     optionId: option.id,
  //     subOptionIds: option.suboption.map(sub => ({
  //       subOptionId: sub.id
  //     }))
  //   }));

  //   setAddOnOptionData(prev => ({
  //     ...prev,
  //     RemoveOptions: [...prev.RemoveOptions, ...removedOptions]
  //   }));

  //   setHasOption(false);
  //   setIsAnyVisible(false);
  //   setIsOptionVisible(false);
  //   setIsButtonVisible(false);
  //   setIsTextBoxVisible(false);
  //   setButtonId(0);
  //   setButtonStyle('');
  //   setAnyValue(0);
  //   setMinSelection(0);
  //   setMaxSelection(0);
  //   setTextBox('');
  //   setOptionVal([]);
  //   setRowsData([]);
  //   }
  // };


  const handleHasOption = () => {
    if (hasOption === false) {
      setHasOption(true);
      if (isCountable) {
        setButtonStyle("Radio Button");
        setButtonId(3);
        setAnyValue(1);
        setMaxSelection(1);
        setMinSelection(0);
        setIsAnyVisible(true);
        setIsOptionVisible(true);
      }
    } else {
      // When turning off "Has Option", clear all option-related state
      setHasOption(false);
      setIsAnyVisible(false);
      setIsOptionVisible(false);
      setIsButtonVisible(false);
      setIsTextBoxVisible(false);
      setButtonId(0);
      setButtonStyle('');
      setAnyValue(0);
      setMinSelection(0);
      setMaxSelection(0);
      setTextBox('');
      // Add all current options to removedItems
      const removedOptions = optionVal.map(option => ({
        optionId: option.id,
        subOptionIds: option.suboption?.map(sub => ({ subOptionId: sub.id })) || []
      }));
      setRemovedItems(prev => [...prev, ...removedOptions]);
      setOptionVal([]);
      setRowsData([]);
      setdefaultoption([]);
    }
  };


  useEffect(() => {
    if (!hasOption) {
      setButtonId(0);
    }
  }, [hasOption]);

  const handleMinSelectionValueChange = (event) => {
    console.log('event', event)
    if (buttonId === 3) {

    }
    else {
      //setAnyValue(event.target.value);
      setMinSelection(event);
    }

  };
  useEffect(() => {
    // Use the most up-to-date values for all components of the inclusive price
    const base = parseFloat(basePrice) || 0;
    const v = parseFloat(vat) || 0;
    const sdVal = parseFloat(SdAmount) || parseFloat(sd) || 0;
    const vatOnSdVal = parseFloat(VatOnSdAmount) || parseFloat(VatOnsd) || 0;

    setNewInclusive((base + v + sdVal + vatOnSdVal).toFixed(2));
  }, [basePrice, vat, SdAmount, sd, VatOnSdAmount, VatOnsd]);


  // Add effect to update VAT when basePrice or percentage changes:
  useEffect(() => {
    setVat(getPercentageOrAmount(basePrice, percentage, "amount"));
  }, [basePrice, percentage]);

  // useEffect(() => {
  //   if (editData && vatDatas.length > 0) {
  //     // Set SD
  //     if (editData.sdId) {
  //       const sdObj = vatDatas.find(v => v.id === editData.sdId);
  //       if (sdObj) {
  //         setsdAdded(sdObj);
  //         setSDPercentage(sdObj.percentage);
  //         setSdType(editData.sdType || "auto");
  //       }
  //     }
  //     // Set Vat On SD
  //     if (editData.vatOnSDId) {
  //       const vatOnSdObj = vatDatas.find(v => v.id === editData.vatOnSDId);
  //       if (vatOnSdObj) {
  //         setVatOnSdAdded(vatOnSdObj);
  //         setVatOnsdPercentage(vatOnSdObj.percentage);
  //         setVatOnSdType(editData.vatOnSDType || "auto");
  //       }
  //     }
  //   }
  // }, [editData, vatDatas]);

  useEffect(() => {
    if (editData && vatDatas.length > 0) {
      // --- SD ---
      setRadiovalueSD(editData.sdType); // Always set the radio value
      if (editData.sdType === "auto" && editData.sdId) {
        const sdObj = vatDatas.find(v => v.id === editData.sdId);
        if (sdObj) {
          setsdAdded(sdObj);
          setSDPercentage(sdObj.percentage);
          setSdInAmount(null);
          setSdAmount(editData.sdInAmount || 0);
        }
      } else if (editData.sdType === "Specify") {
        setsdAdded(null);
        setSDPercentage(editData.sDinPercentage || 0);
        setSdInAmount(editData.sDinPercentage || 0);
        setSdAmount(editData.sdInAmount || 0);
      } else if (editData.sdType === "Fixed") {
        setsdAdded(null);
        setSDPercentage(null);
        setSdInAmount(null);
        setSdAmount(editData.sdInAmount || 0);
      }

      // --- Vat On SD ---
      setRadiovalueVatonSD(editData.vatOnSDType || "auto"); // Always set the radio value

      if (editData.vatOnSDType === "auto" && editData.vatOnSDId) {
        const vatOnSdObj = vatDatas.find(v => v.id === editData.vatOnSDId);
        if (vatOnSdObj) {
          setVatOnSdAdded(vatOnSdObj);
          setVatOnsdPercentage(vatOnSdObj.percentage);
          setVatOnSdInAmount(null);
          setVatOnSdAmount(editData.vatOnSdAmount || 0); // If you store amount
        }
      } else if (editData.vatOnSDType === "Specify") {
        setVatOnSdAdded(null);
        setVatOnsdPercentage(editData.vatInSDPercentage || 0);
        setVatOnSdInAmount(editData.vatInSDPercentage || 0);
        setVatOnSdAmount(editData.vatOnSdAmount || 0); // If you store amount
      }
    }
  }, [editData, vatDatas]);

  useEffect(() => {
    if (editData && typeof editData.isSD === "boolean") {
      setsdSwitch(editData.isSD);
      // Optionally, also set sdEnabled if needed
      setsdEnabled(!editData.isSD);
    }
  }, [editData]);


  console.log(addonsData)
  console.log(editData)
  // useEffect(() => {
  //   if (editData && editData.optionData) {
  //     // Check if any option has isSD=true
  //     const hasSDOption = editData.optionData.some(option => 
  //       option.isSD 
  //     );

  //     // Check if any option is countable
  //     const hasCountableOption = editData.optionData.some(option => 
  //       option.isCountable 
  //     );

  //     if (hasSDOption) {
  //       setsdSwitch(false);
  //       setIsSdSwitchActive(true); // Disable the SD switch
  //     }

  //     if (hasCountableOption) {
  //       setIsCountable(false);
  //       setIsCountableActive(true); // Disable the countable switch
  //     }
  //   }
  // }, [editData]);
  useEffect(() => {
    if (editData?.optionData) {
      const hasSDOption = editData.optionData.some(option => option.isSD);
      const hasCountableOption = editData.optionData.some(option => option.isCountable);

      setIsSdSwitchActive(hasSDOption);
      setIsCountableActive(hasCountableOption);

      if (hasSDOption) {
        setsdSwitch(false);
        setsdEnabled(true);
      }

      if (hasCountableOption) {
        setIsCountable(false);
      }
    }
  }, [editData?.optionData]);

  useEffect(() => {
    const base = parseFloat(basePrice) || 0;
    const v = parseFloat(vat) || 0;
    const sdVal = parseFloat(sd) || 0;
    const vatOnSdVal = parseFloat(VatOnsd) || 0;
    setNewInclusive((base + v + sdVal + vatOnSdVal).toFixed(2));
  }, [basePrice, vat, sd, VatOnsd]);

  useEffect(() => {
    // Ensure both values are numbers
    const sdAmountNum = parseFloat(SdAmount) || 0;
    const vatOnSdPercentNum = parseFloat(VatOnSdInAmount) || 0;

    // Calculate VAT (Amount) as (VAT % of SD Amount)
    const vatAmount = (vatOnSdPercentNum / 100) * sdAmountNum;
    setVatOnSdAmount(vatAmount.toFixed(2));
  }, [SdAmount, VatOnSdInAmount]);

  const AddVatOnSdAmount = (props) => {
    if (radiovalueVatonSD === "Fixed") {
      setVatOnSdAmount(props);
      updateInclusive(basePrice, vat, sd, props);
    }
  };


  const setSdInAmountAdd = (props) => {

  };
  const setVatOnSdInAmountAdd = (props) => {
  };



  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      setLoading(true);
      await loadOptionByRestaurant();
      if (props.editData?.optionData) {
        await loadOptionSuboptionListByOptionI(props.editData.optionData);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);


  const hasSDOption = useCallback(() => {
    return optionVal.some(option => option.isSD);
  }, [optionVal]);


  useEffect(() => {
    if (hasSDOption()) {
      // If any option has isSD=true, turn off the SD switch and clear values
      setsdSwitch(false);
      setsdEnabled(true);

      // Clear SD values
      setsdAdded(null);
      setCustomSD("");
      setSdInAmount(0);
      setSdAmount(0);
      setRadiovalueSD("auto");

      // Clear Vat On SD values
      setVatOnSdAdded(null);
      setCustomVatonSD("");
      setVatOnSdInAmount(0);
      setVatOnSdAmount(0);
      setRadiovalueVatonSD("auto");
    }
  }, [optionVal, hasSDOption]);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  // Add this near the top of the component, after state declarations
  useEffect(() => {
    if (props.editData) {
      setButtonId(props.editData.optionButtonId);
      setMinSelection(props.editData.minSelection ?? "");
      setAnyValue(props.editData.maxSelection ?? "");
    }
  }, [props.editData]);

  const handleOptionCloseOnSuccess = () => {
    setOpenEditOption(false)
    loadOptionByRestaurant()
    loadData()
  };

  return (
    <Dialog open={open} onClose={onClose} className="" fullWidth={true} maxWidth={'lg'}>
      <LoadingView open={loadingModal} close={closeLoadingModal} />
      <SweetAlertModal headerText={"Are you sure?"} bodyText={"You want to save this?"} open={openConfirmaitonModal} onyes={handleSave} close={() => { setopenConfirmaitonModal(false) }} />
      <DialogTitle disableTypography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
          <Typography variant="h6" className="textColor">
            {props.dialogName}
          </Typography>
          <IconButton aria-label="close" className="closeButton" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className="textColor">
        <Grid container className="gridSpecificationContainer" spacing={3} alignItems="center">
          <Grid item xs={3}>
            <Typography className="textColor">Addon Name</Typography>
          </Grid>
          <Grid item xs={9}>
            {/* <TextField label="Name" value={name} onChange={handleNameChange} fullWidth margin="normal" InputLabelProps={{ sx: { color: '#371B17' } }} /> */}
            <TextAreaComponents label={'Name'} value={nameFieldValue} val={name} />

          </Grid>
        </Grid>
        <Grid container className="gridSpecificationContainer" spacing={3} alignItems="center">
          <Grid item xs={3}>
            <Typography className="textColor">Collapse option list</Typography>
          </Grid>
          <Grid item xs={9}>
            <Switch
              checked={switchCollapsableCheck}
              onChange={handleswitchCollapsableCheck}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            {switchCollapsableCheck ? "Yes" : "Auto"}

          </Grid>
        </Grid>
        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Base Price</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              placeholder={"Base Price"}
              onChange={(e) => { handleBasePrice(e) }}
              value={basePrice}
              fullWidth
              disabled={isActive}
              inputProps={{
                style: {
                  cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                },
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">VAT</Typography>
          </Grid>
          <Grid container item xs={9} direction="row" spacing={2}>
            <Grid item xs={6}>
              <TextField
                placeholder={"VAT percentage"}
                onChange={(e) => { handleSetPercentage(e) }}
                value={percentage}
                fullWidth
                disabled={isActive}
                inputProps={{
                  style: {
                    cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                placeholder="VAT amount"
                onChange={(e) => handleSetVat(e)}
                value={vat}
                fullWidth
                disabled={isActive}
                inputProps={{
                  style: {
                    cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Add the SD and VAT on SD sections similar to AddSpecification */}
        <Grid container className="gridSpecificationContainer" spacing={5} alignItems="center">
          <Grid item xs={3}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography className="textColor">SD</Typography>
              {/* <Switch 
              checked={sdSwitch}
              onChange={handleSDSwitch}
              inputProps={{ "aria-label": "controlled" }}
              disabled={isSdSwitchActive || hasSDOption()}
            /> */}
              <Switch
                checked={sdSwitch}
                onChange={handleSDSwitch}
                disabled={isSdSwitchActive}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Box>
          </Grid>

          <Grid container item xs={9} direction="row" spacing={2}>
            <Grid item xs={12}>
              <RadioGroup
                row
                name="sd-radio-buttons-group"
                value={radiovalueSD}
                onChange={handleRadioChangeSD}
              >
                <FormControlLabel value="auto" control={<Radio />} label="Select from SD List" />
                <span style={{ padding: "0.5rem" }}> - Or - </span>
                <FormControlLabel value="Specify" control={<Radio />} label="Specify SD" />
                <span style={{ padding: "0.5rem" }}> - Or - </span>
                <FormControlLabel value="Fixed" control={<Radio />} label="Fixed SD" />
              </RadioGroup>
            </Grid>

            {radiovalueSD === "auto" && (
              <Grid item xs={4}>
                <Autocomplete
                  id="free-solo-with-text-demo"
                  options={vatDatas}
                  value={sdAdded}
                  onChange={(event, newInputValue) => {
                    setsdAdded(newInputValue);
                    setSdId(newInputValue?.id || null);
                  }}
                  getOptionLabel={(option) => option?.title || ""}
                  disabled={sdEnabled}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Select SD"
                      disabled={radiovalueSD !== "auto"}
                    />
                  )}
                />
              </Grid>
            )}

            {radiovalueSD === "Specify" && (
              <Grid item xs={4}>
                <TextField
                  placeholder="Specify SD Percentage"
                  variant="outlined"
                  value={customSD}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || Number(value) >= 0) {
                      setCustomSD(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                  type="number"
                  disabled={sdEnabled}
                  fullWidth
                />
              </Grid>
            )}

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="SD (%)"
                value={setSdInAmountAdd}
                val={SdInAmount !== 0 ? SdInAmount : ""}
                placeholder="SD (%)"
                isactive={isactive}
                disabled={sdEnabled}
              />
            </Grid>

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="SD (Amount)"
                value={inAmountSDValue}
                val={SdAmount}
                isactive={isactive}
                disabled={sdEnabled}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid container className="gridSpecificationContainer" spacing={3} alignItems="center">
          <Grid item xs={3}>
            <Typography className="textColor">VAT On SD</Typography>
          </Grid>
          <Grid container item xs={9} direction="row" spacing={2}>
            <Grid item xs={12}>
              <RadioGroup
                row
                name="vat-sd-radio-buttons-group"
                value={radiovalueVatonSD}
                onChange={handleRadioChangeVatOnSD}
              >
                <FormControlLabel value="auto" control={<Radio />} label="Select from VAT List" />
                <span style={{ padding: "0.5rem" }}> - Or - </span>
                <FormControlLabel value="Specify" control={<Radio />} label="Specify VAT On SD" />
              </RadioGroup>
            </Grid>

            {radiovalueVatonSD === "auto" && (
              <Grid item xs={4}>
                <Autocomplete
                  id="select-vat"
                  options={vatDatas}
                  value={vatOnSdAdded}
                  onChange={(event, newInputValue) => {
                    setVatOnSdAdded(newInputValue);
                    setVatOnSdId(newInputValue?.id || null);
                  }}
                  getOptionLabel={(option) => option?.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select VAT"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                  disabled={sdEnabled}
                />
              </Grid>
            )}

            {radiovalueVatonSD === "Specify" && (
              <Grid item xs={4}>
                <TextField
                  placeholder="Specify VAT (%)"
                  variant="outlined"
                  value={customVatonSD}
                  type="number"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || Number(value) >= 0) {
                      setCustomVatonSD(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                  disabled={sdEnabled}
                  fullWidth
                />
              </Grid>
            )}

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="VAT (%)"
                //value={setVatOnSdInAmount}
                value={setVatOnSdInAmountAdd}
                val={VatOnSdInAmount !== 0 ? VatOnSdInAmount : ""}
                placeholder="VAT (%)"
                isactive={isactive}
                disabled={sdEnabled}
              />
            </Grid>

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="VAT (Amount)"
                //value={setVatOnSdAmount}
                value={AddVatOnSdAmount}
                val={VatOnSdAmount}
                disabled={sdEnabled}
                isactive={isactive}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Inclusive</Typography>
          </Grid>
          <Grid item xs={9}>
            {/* <TextField
              placeholder={"Inclusive"}
              value={newInclusive}
              fullWidth
              disabled={isActive}
              inputProps={{
                style: {
                  cursor: isActive ? "not-allowed" : "text", 
                },
              }}
            /> */}
            <TextField
  value={newInclusive}
  onChange={handleInclusiveChange}
/>

          </Grid>
        </Grid>

        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">
              Is countable
            </Typography>
          </Grid>
          <Grid item xs={9}>
            {/* <Switch
              checked={isCountable}
              onChange={handleIsCountable}
              inputProps={{ "aria-label": "controlled" }}
              disabled={isCountableActive}
            /> */}
            <Switch
              checked={isCountable}
              onChange={handleIsCountable}
              disabled={isCountableActive}
              inputProps={{ "aria-label": "controlled" }}
            />
            <HtmlTooltip
              title={
                <React.Fragment>
                  <Typography color="inherit">
                    Check this if your item is countable
                  </Typography>
                </React.Fragment>
              }
            >
              <InfoOutlinedIcon style={{ color: "#371B17" }} />
            </HtmlTooltip>
          </Grid>
        </Grid>

        {/* <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">
              User can select item quantity
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <Switch
              checked={switchUserCanSelectQty}
              onChange={handleUserCanSelectQty}
              inputProps={{ "aria-label": "controlled" }}
            />
            <HtmlTooltip
              title={
                <React.Fragment>
                  <Typography color="inherit">
                    Set the minimum/maximum amount of items the customer can
                    order.
                  </Typography>
                </React.Fragment>
              }
            >
              <InfoOutlinedIcon style={{ color: "#371B17" }} />
            </HtmlTooltip>
          </Grid>
        </Grid> */}
        <>
          <Grid
            container
            className="gridSpecificationContainer"
            spacing={3}
            alignItems="center"
          >
            <Grid item xs={3}>
              <Typography className="textColor">Min Qty</Typography>
            </Grid>
            <Grid item xs={9}>
              {/* <TextField
                placeholder={"Min Qty"}
                onChange={(e) => { handelMinQty(e) }}
                value={minQty}
                fullWidth
                disabled={isActive}
                inputProps={{
                  style: {
                    cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                  },
                }}
              /> */}
              <TextField
                placeholder={"Min Qty"}
                onChange={handelMinQty}
                value={minQty}
                fullWidth
                disabled={isActive}
                error={MinQtyLimitErr}
                helperText={MinQtyLimitErr ? "Min Qty must be greater than 0" : ""}
                inputProps={{ min: 1 }}

              />
            </Grid>
          </Grid>
          <Grid
            container
            className="gridSpecificationContainer"
            spacing={3}
            alignItems="center"
          >
            <Grid item xs={3}>
              <Typography className="textColor">
                Increamental Qty
              </Typography>
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <Typography color="inherit">
                      Set the amount by which to increment the order
                      quantity. For example, if the current quantity is 1
                      and the user clicks on the + sign to increment it,
                      and the minimum increment is 3, the quantity will
                      increase by 3 and be set to 4 and so on
                    </Typography>
                  </React.Fragment>
                }
              >
                <InfoOutlinedIcon style={{ color: "#371B17" }} />
              </HtmlTooltip>
            </Grid>
            <Grid item xs={9}>
              <TextField
                placeholder={"Increamental Qty"}
                onChange={(e) => { handelincreamentalQty(e) }}
                value={increamentalQty}
                fullWidth
                disabled={isActive}
                inputProps={{
                  style: {
                    cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                  },
                }}
              />
            </Grid>
          </Grid>
          <Grid
            container
            className="gridSpecificationContainer"
            spacing={3}
            alignItems="center"
          >
            <Grid item xs={3}>
              <Typography className="textColor">Max Qty</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                placeholder={"Max Qty"}
                onChange={(e) => { handelMaxQty(e) }}
                value={maxQty}
                fullWidth
                disabled={isActive}
                inputProps={{
                  style: {
                    cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                  },
                }}
              />
            </Grid>
          </Grid>
        </>

        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">
              Has Option
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <Switch
              checked={hasOption}
              onChange={handleHasOption}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Grid>
        </Grid>


        {hasOption && (
          <Grid container className="gridSpecificationContainer" spacing={3} alignItems="center">
            <Grid item xs={3}>

              <div className='d-flex' style={{ paddingTop: '1rem', gap: '10px' }}>
                <Typography >
                  Option button style
                </Typography>
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit">If this add-on has an option list
                        (for examle the add-on named 'Sauces' can have options 'salsa sauce', cheese sauce, etc),
                        then select the type of button the user clicks on to select each option
                      </Typography>
                    </React.Fragment>
                  }>
                  <InfoOutlinedIcon style={{ color: '#371B17' }} />
                </HtmlTooltip>
              </div>
            </Grid>
            <Grid item xs={9}>
              <RadioGroup aria-label="buttonStyle" name="buttonStyle" value={buttonStyle} onChange={handleButtonStyleChange} row>
                <FormControlLabel value="Radio Button" control={<Radio size="small" />} label={
                  <Typography variant="body2" className="textColor">
                    Radio Button
                  </Typography>
                }
                  sx={radioSpecification}
                />
                <FormControlLabel value="Check Box" control={<Radio size="small" />} label={
                  <Typography variant="body2" className="textColor">
                    Check Box
                  </Typography>
                }
                  sx={radioSpecification}
                />
                <FormControlLabel value="Button" control={<Radio size="small" />} label={
                  <Typography variant="body2" className="textColor">
                    Button
                  </Typography>
                }
                  sx={radioSpecification}
                  disabled={isCountable}
                />
                <FormControlLabel value="TextBox" control={<Radio size="small" />} label={
                  <Typography variant="body2" className="textColor">
                    TextBox
                  </Typography>
                }
                  sx={radioSpecification}
                  disabled={isCountable}
                />
              </RadioGroup>
            </Grid>
          </Grid>
        )}

        {switchQuantityCheck ? (
          <>
            <Grid container className="gridSpecificationContainer" spacing={3} alignItems="center">
              <Grid item xs={3}>
                <Typography className="textColor">Min quantity</Typography>
              </Grid>
              <Grid item xs={9}>
                <TextAreaComponents id={2} label={'Min quantity'} value={textFieldValue} />

              </Grid>
            </Grid>
            <Grid container className="gridSpecificationContainer" spacing={3} alignItems="center">
              <Grid item xs={3}>
                <Typography className="textColor">Max quantity</Typography>
              </Grid>
              <Grid item xs={9}>
                <TextAreaComponents id={2} label={'Max quantity'} value={textFieldValue} />

              </Grid>
            </Grid>
          </>

        ) : ("")}
        {isAnyVisible && (
          <>
            <Grid
              container
              className="gridSpecificationContainer"
              spacing={2}
              alignItems="center"
            >
              <Grid item xs={3}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <Typography>Min Selection</Typography>
                  {buttonId == 3 && (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            If button type is "Radio Button" then Min selection will Always be 0.
                          </Typography>
                        </React.Fragment>
                      }
                    >
                      <InfoOutlinedIcon style={{ color: "FF0000" }} />
                    </HtmlTooltip>
                  )}
                  {buttonId == 4 && (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            Restrict the maximum number of different add-on
                            options the user can select. For example, if the
                            add-on is 'Sauce' and the options are 'Salsa',
                            'Cheese' or 'Tomato', you can restrict the selection
                            to 1, and the user can only select 1of either sauce
                            options and no more (if you allow the user to set the
                            quantity he needs, then this will still apply, for
                            example, 3 'Tomato' sauce sachets)
                          </Typography>
                        </React.Fragment>
                      }
                    >
                      <InfoOutlinedIcon style={{ color: "#371B17" }} />
                    </HtmlTooltip>
                  )}
                </div>
              </Grid>
              <Grid item xs={9}>
                <TextAreaComponents
                  id={2}
                  label={"Min Selection"}
                  value={handleMinSelectionValueChange}
                  val={minSelection}
                  isactive={buttonId === 3}
                />
              </Grid>
            </Grid>
          </>
        )}
        {isAnyVisible && (
          <>
            <Grid
              container
              className="gridSpecificationContainer"
              spacing={2}
              alignItems="center"
              style={{ marginTop: "-1rem" }}
            >
              <Grid item xs={3}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "0rem", gap: "10px" }}
                >
                  <Typography>Max Selection</Typography>
                  {buttonId == 3 && (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            If button type is "Radio Button" then user will only be able to select maximun 1 option.
                          </Typography>
                        </React.Fragment>
                      }
                    >
                      <InfoOutlinedIcon style={{ color: "FF0000" }} />
                    </HtmlTooltip>
                  )}
                  {buttonId == 4 && (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            Restrict the maximum number of different add-on
                            options the user can select. For example, if the
                            add-on is 'Sauce' and the options are 'Salsa',
                            'Cheese' or 'Tomato', you can restrict the selection
                            to 1, and the user can only select 1of either sauce
                            options and no more (if you allow the user to set the
                            quantity he needs, then this will still apply, for
                            example, 3 'Tomato' sauce sachets)
                          </Typography>
                        </React.Fragment>
                      }
                    >
                      <InfoOutlinedIcon style={{ color: "#371B17" }} />
                    </HtmlTooltip>
                  )}
                </div>
              </Grid>
              <Grid item xs={9}>
                <TextAreaComponents
                  id={2}
                  label={"Max Selection"}
                  value={handleAnyValueChange}
                  val={anyValue}
                  isactive={buttonId === 3}
                />
              </Grid>
            </Grid>
          </>
        )}
        {isTextBoxVisible && (
          <Grid container className="gridSpecificationContainer" spacing={3} alignItems="center">
            <Grid item xs={3}>
              <Typography className="textColor">Text Box Name</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField label="Complimentary" value={textBox} onChange={handleTextBoxChange} fullWidth margin="normal" />
            </Grid>
          </Grid>
        )}
        {(isOptionVisible && sectionDatas.length > 0) ? (
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={3} style={{ margin: '0 auto auto' }}>
              <Typography className="textColor">Option</Typography>
            </Grid>
            <Grid item xs={9}>
              <Grid container sx={{ alignItems: "center" }} spacing={2}>
                <Grid item xs={10}>
                  {defaultOption?.length > 0 ? (
                    // <Autocomplete
                    //   key={defaultOption?.length}
                    //   multiple
                    //   id="tags-outlined"
                    //   clearText="clear"
                    //   options={sectionDatas}
                    //   getOptionLabel={(option) => option.title}
                    //   isOptionEqualToValue={(option, value) => option.id === value.id}
                    //   filterSelectedOptions
                    //   onChange={(event, newInputValue, reason, detail) => {
                    //     addonvalue(newInputValue);

                    //     if (reason === 'removeOption') {
                    //       handleOptionRemove(detail.option)
                    //     }
                    //   }}
                    //   defaultValue={defaultOption}
                    //   renderInput={(params) => (
                    //     <TextField
                    //       {...params}
                    //       label={''}
                    //       placeholder={"Add Option"}
                    //       required={true}
                    //     />
                    //   )}
                    //   value={props.val}
                    // />
                    <Autocomplete
                      multiple
                      id="tags-outlined"
                      options={sectionDatas}
                      getOptionLabel={(option) => option.title}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      value={optionVal}
                      onChange={(event, newValue, reason, details) => {
                        if (reason === 'removeOption') {
                          handleOptionRemove(details.option);
                        }
                        setOptionVal(newValue);
                        loadOptionSuboptionListByOptionI(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label=""
                          placeholder="Add Option"
                        />
                      )}
                    />
                  ) :
                    <Autocomplete
                      key={defaultOption.length}
                      multiple
                      id="tags-outlined"
                      clearText="clear"
                      options={sectionDatas}
                      getOptionLabel={(option) => option.title}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      filterSelectedOptions
                      onChange={(event, newInputValue, reason, detail) => {
                        addonvalue(newInputValue);

                        if (reason === 'removeOption') {
                          handleOptionRemove(detail.option)
                        }
                      }}
                      defaultValue={defaultOption}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={''}
                          placeholder={"Add Option"}
                          required={true}
                        />
                      )}
                      value={props.val}
                    />
                  }
                </Grid>

                <Grid item xs={2}>
                  <div className='d-flex TooltipClass align-items-center' >
                    <Typography className="textColor" onClick={handleAddOptionClick}
                    style={{ cursor: "pointer" }}>
                      +Add Options
                    </Typography>

                  </div>
                </Grid>
              </Grid>



              <AddOption open={openOptionDialog} onClose={() => setOpenOptionDialog(false)} reloadOption={ReloadOption} onSave={handleAddOptionSave} />
              <br></br>
              <div style={{ width: '100%' }}>



                {
                  rowsData?.length > 0 ? (
                    <TableContainer component={Paper}>
                      <Table aria-label="collapsible table">
                        <TableHead>
                          <TableRow>
                            <TableCell />
                            <TableCell>AddOn Name</TableCell>
                            <TableCell align="right">BasePrice</TableCell>
                            <TableCell align="right">Vat</TableCell>
                            <TableCell align="right">SD</TableCell>
                            <TableCell align="right">Vat On SD</TableCell>
                            <TableCell align="right">InclusivePrice</TableCell>
                            <TableCell align="right">Min Qty</TableCell>
                            <TableCell align="right">Max Qty</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsData.map((row, idx) => (
                            <Row key={row.name} row={row} idx={idx} />
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : ""
                }


              </div>
            </Grid>
          </Grid>
        ) : ""}
      </DialogContent>
      <DialogActions>
        <Button className="textColor btn" onClickCapture={() => setopenConfirmaitonModal(true)}>
          Save
        </Button>
      </DialogActions>

      {OpenEditOption &&
        <EditOption
          open={OpenEditOption}
          handleEditOptionClose={handleEditOptionClose}
          editData={EditOptionObj}
          onOptionModelClose={handleOptionCloseOnSuccess}
        />}
    </Dialog>
  )
}

export default EditSpecification